/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaEraser } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Add, Delete, Search } from '@mui/icons-material'
import CloseIcon from '@mui/icons-material/Close'
import TuneIcon from '@mui/icons-material/Tune'
import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import Badge from '@mui/material/Badge'
import { styled } from '@mui/material/styles'
import { debounce } from 'lodash'

import { AppDispatch, RootState } from 'redux/store'

import { Form, Formik } from 'formik'

import InputField from 'components/atoms/fields/InputField'

import { useMedia } from 'utils/customHooks/useMedia'
import { actionButton, PRIMARY_YELLOW, PURE_BLACK, PURE_WHITE } from 'utils/customizedTheme'

interface IProps {
  children?: JSX.Element
  reduxKey: string
  api: any
  tag: any
  entityName: string
  title?: string
  addLabel?: string
  setSearch?: any
  activeFilters?: string[]
  formModel: any
  initialValues: any
  featuredExtraActions?: any
  featuredExtraFilters?: any
  clearAllFilters: any
  openFilters?: boolean
  searchBarSize?: number
  hideSearchBar?: boolean
  hideDefaultActions?: boolean
  baseUrl?: string
}
const MainTableFiltersForm: FC<IProps> = ({
  children,
  reduxKey,
  api,
  tag,
  entityName,
  addLabel,
  title,
  setSearch,
  activeFilters,
  clearAllFilters,
  formModel,
  initialValues,
  featuredExtraActions,
  featuredExtraFilters,
  searchBarSize = 4,
  hideSearchBar = false,
  hideDefaultActions = false,
  openFilters = false,
  baseUrl = ''
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const { isUnder1200px } = useMedia()

  const bulkDelete = useSelector((state: RootState) => state[reduxKey].bulkDelete)

  const { search } = formModel()

  const debounceSearch = useCallback(
    debounce((value, action) => {
      dispatch(api.util.invalidateTags([tag]))
      dispatch(action(value))
    }, 600),
    [],
  )
  const [open, setOpen] = useState(false)

  const FiltersFlag = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      padding: 0,
      top: '4px',
      right: '4px',
    },
  }))

  return (
    <Box
      sx={{
        padding: '1rem',
        paddingTop: '0px',
        paddingLeft: '0px',
        paddingRight: '0px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      }}
    >
      <Formik initialValues={initialValues} validationSchema={null} onSubmit={null}>
        {({ handleReset }) => (
          <Form style={{ width: '100%' }}>
            <Grid container rowSpacing={2} columnSpacing={2} sx={{ paddingLeft: '0px', alignItems: 'center' }}>
        
              {openFilters && <>

                {children}

                {/*
                <Grid item xs={12} md={6} sx={{ display: 'flex' }}>

                  <div>     
                    <Button
                        disableElevation
                        variant='contained'
                        color='error'
                        onClick={() => {
                          dispatch(clearAllFilters())
                          handleReset()
                        }}
                        aria-label='close'
                      >
                        <FaEraser />
                        <span style={{ marginLeft: '10px', display: 'inline-block' }}>{`${t(
                          'common.clear-filters',
                        )}`}</span>
                      </Button>

                      <Button
                        disableElevation
                        variant='contained'
                        color='success'
                        onClick={() => setOpen(false)}
                        aria-label='close'
                        sx={{ marginLeft: '10px' }}
                      >
                        <span style={{ marginLeft: '0.5rem', display: 'inline-block' }}>{`${t(
                          'common.search',
                        )}`}</span>
                      </Button>

                  </div>     

                </Grid>*/}
              </>}
              


              {!hideSearchBar && !openFilters && (
                <Grid item xs={9} lg={searchBarSize} sx={{ marginBottom: '-0.75rem' }}>
                  <InputField
                    fieldProps={{ ...search }}
                    icon={<Search sx={{ mr: 1, my: 0.5, color: PURE_BLACK }} />}
                    onChange={(value: string) => debounceSearch(value, setSearch)}
                    sx={{
                      paddingBottom: '0',
                      width: '100%',
                      background: theme.palette.background.default,
                    }}
                  />
                </Grid>
              )}
              {activeFilters && !openFilters && (
                <Grid item xs={3} lg={2} style={{ whiteSpace: 'nowrap' }}>

                    {
                      title && 
                        <span className="page-section-title" 
                          style={{ whiteSpace: 'nowrap', position: 'relative', bottom: '-4px' }}>{title}</span>
                    }
                    
                  <FiltersFlag
                    badgeContent={
                      open ? null : activeFilters?.length ? (
                        activeFilters?.length
                      ) : bulkDelete?.length && isUnder1200px ? (
                        <Delete sx={{ maxWidth: '0.75rem' }} />
                      ) : null
                    }
                    color='success'
                    sx={{ padding: '0 !important' }}
                  >
                    <Button
                      variant='contained'
                      color={open || activeFilters.length ? 'primary' : 'white'}
                      aria-label='expand row'
                      onClick={() => setOpen(!open)}
                      disableElevation
                      sx={{
                        background: 'none',
                        '&:hover': {
                          background: theme.palette.primary.main,
                          border: 'none',
                          '& svg': { color: '#000' },
                        },
                        width: '2.75rem',
                        height: '2.75rem',
                        padding: '0',
                        minWidth: 'auto',
                        marginRight: '0.2rem',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <TuneIcon sx={{ fontSize: '1.9rem' }} />
                    </Button>
                  </FiltersFlag>
                </Grid>
              )}
              
              {featuredExtraFilters && featuredExtraFilters}
              <Grid item xs={12} lg={hideSearchBar ? 12 : 6} display='flex' justifyContent={isUnder1200px ? 'flex-start' : 'flex-end'} alignItems='center'>
                  <>
                    {featuredExtraActions}
                    {!hideDefaultActions && <ActionButtons baseUrl={baseUrl} addLabel={addLabel} bulkDelete={bulkDelete} />}
                  </>
              </Grid>
            </Grid>

            {/* DIALOG */}
            {!openFilters &&
            <Dialog
              onClose={() => setOpen(false)}
              open={open}
              fullWidth
              maxWidth='xl'
              PaperProps={{
                sx: {
                  margin: 0,
                  padding: 0,
                  width: { xs: '100vw', md: '80vw' },
                  maxWidth: { xs: '100vw', md: '80vw' },
                  background: theme.palette.background.default,
                },
              }}
            >
              <Grid
                container
                rowSpacing={5}
                columnSpacing={{ sx: 0, md: 5 }}
                sx={{
                  marginTop: '-0.5rem',
                  width: '100%',
                  overflowX: 'hidden',
                  overflowY: 'auto',
                  padding: { xs: '0rem 1rem 2rem', md: '0rem 3rem 2rem' },
                  marginLeft: '0rem',
                  marginBottom: '2rem',
                }}
              >
                <Grid item xs={12}>
                  <Typography
                    component='h2'
                    sx={{
                      textAlign: 'center',
                      fontWeight: '600',
                      fontSize: '1.7rem',
                      fontFamily: 'Newsreader',
                      color: PURE_BLACK,
                      padding: '0.5rem 1rem',
                      backgroundColor: PRIMARY_YELLOW,
                      position: 'relative',
                      width: 'calc(100% + 6rem)',
                      margin: '-2rem 0 1rem -3rem',
                    }}
                  >
                    {`${entityName} ${t('common.table-filters')}`}
                    <IconButton
                      onClick={() => setOpen(false)}
                      aria-label='close'
                      sx={{
                        marginRight: '-0.5rem',
                        color: PURE_BLACK,
                        position: 'absolute',
                        top: '0.35rem',
                        right: { xs: '3rem', md: '1rem' },
                      }}
                    >
                      <CloseIcon sx={{ fontSize: '2rem' }} />
                    </IconButton>
                  </Typography>
                </Grid>

                {isUnder1200px && featuredExtraFilters}
                {children}
                <Grid item xs={12} mt={1} sx={{ display: 'flex' }}>

                  <div style={{ marginLeft: 'auto' }}>     
                    <Button
                        disableElevation
                        variant='contained'
                        color='error'
                        onClick={() => {
                          dispatch(clearAllFilters())
                          handleReset()
                        }}
                        aria-label='close'
                      >
                        <FaEraser />
                        <span style={{ marginLeft: '10px', display: 'inline-block' }}>{`${t(
                          'common.clear-filters',
                        )}`}</span>
                      </Button>

                  
                    <Button
                      disableElevation
                      variant='contained'
                      color='success'
                      onClick={() => setOpen(false)}
                      aria-label='close'
                      sx={{ marginLeft: '10px' }}
                    >
                      <span style={{ marginLeft: '0.5rem', display: 'inline-block' }}>{`${t(
                        'common.apply',
                      )}`}</span>
                    </Button>

                  </div>     

                </Grid>
              </Grid>
            </Dialog>}
          </Form>
        )}
      </Formik>
    </Box>
  )
}
export default MainTableFiltersForm

const ActionButtons = ({ addLabel, bulkDelete, baseUrl }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const theme = useTheme()
  const isUnder1200px = useMediaQuery(theme.breakpoints.down('md'))

  const handleBulkDelete = () => {}

  return (
    <section>
      <Tooltip title={`${t('common.add')}`} arrow placement='top'>
        <Button
          variant='contained'
          color='success'
          aria-haspopup='true'
          onClick={() => navigate(`${baseUrl}add`)}
          disableElevation
          sx={{ 
            ...actionButton,
            lineHeight: '1rem'
          }}
          fullWidth={isUnder1200px}
        >
          <Add />
          <span>{addLabel || ''}</span>
        </Button>
      </Tooltip>

      {bulkDelete?.length > 0 && (
        <Button
          variant='contained'
          color='error'
          aria-haspopup='true'
          onClick={handleBulkDelete}
          sx={{
            height: '2.5rem',
            padding: '0.2rem 1rem 0.2rem 0.6rem',
            marginLeft: { md: '0.5rem' },
            marginTop: { xs: '0.5rem', md: 0 },
            lineHeight: '1rem'
          }}
          fullWidth={isUnder1200px}
        >
          <Delete sx={{ marginRight: '0.5rem' }} />
          {`${t('common.delete')}`}
        </Button>
      )}
    </section>
  )
}
